import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-createsession',
  templateUrl: './createsession.component.html',
  styleUrls: ['./createsession.component.css']
})
export class CreatesessionComponent implements OnInit {

  constructor(private sharedService:SharedService,private router:Router,private globalHelper :GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) {
    
  }
  Submitted = false;  
  SessionModel = {
    LogoPath: '',
    SessionID: 0,
    Session: '',
    SessionStartDate: '',
    SessionEndDate: '',
    SessionStatus: '0',
    IsActive: false,
    BranchID: 0
  };

  Clear() {
    this.SessionModel.LogoPath = '';
    this.SessionModel.Session = '';
    this.SessionModel.SessionStartDate = '';
    this.SessionModel.SessionEndDate = '';
    this.SessionModel.SessionStatus = '0';
    this.Submitted = false;   

  };
  SaveSession(valid) {

    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.sharedService.SaveSession(JSON.stringify(this.SessionModel)).subscribe((response: any) => {
        this.spinnerService.hide();
        if (response.webResponse.Status) {
          this.router.navigate(['/academicselection']);
      }
       this.globalHelper.CheckActionStatus(response)
      });
    }
  };

  ngOnInit() {
  }

}
